module.exports = __webpack_public_path__ + "img/no_result.4f8c2d15.png";